import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TrainingForm from '../TrainingForm';

const EditTraining = ({ state, dispatch, updateFieldCreator, errors, updateTraining, removeError }) => {
  const { t } = useTranslation();

  return (
    <TrainingForm
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      removeError={removeError}
      onSubmit={(body, history) => updateTraining(state.id, body, history)}
      heading={t('page.ma.cpdManagement.trainings.editTraining')}
    />
  );
};

EditTraining.propTypes = {
  state: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  updateFieldCreator: PropTypes.func.isRequired,
  errors: PropTypes.object,
  updateTraining: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
};

EditTraining.defaultProps = {
  errors: {},
};

export default EditTraining;
